import { render, staticRenderFns } from "./EmployeeContract.vue?vue&type=template&id=4f632cb4&lang=pug&"
import script from "./EmployeeContract.vue?vue&type=script&lang=js&"
export * from "./EmployeeContract.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeContract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmployeeContract.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
})
